import { skipToken } from '@reduxjs/toolkit/query/react';
import documentsAPISlice from 'api/documents/documentsAPISlice';
import usersAPISlice from 'api/users/usersAPISlice';
import { type CharityDocument } from 'features/documents/types';

import { FR_DOCUMENTS } from './frDocuments';

const FR_DOCUMENT_TYPES = FR_DOCUMENTS.map((document) => document.documentType);

export const useVettingDocuments = (
  isFR: boolean,
): {
  documents: CharityDocument[];
  isLoading: boolean;
  isError: boolean;
  charityId: string | undefined;
} => {
  const {
    data: currentUser,
    isLoading: isCurrentUserLoading,
    isError: isCurrentUserError,
  } = usersAPISlice.endpoints.getCurrentUser.useQuery(isFR ? undefined : skipToken);

  const {
    data,
    isLoading: isDocumentsLoading,
    isError: isDocumentsError,
  } = documentsAPISlice.endpoints.listDocuments.useQuery(
    isFR && currentUser?.charityId
      ? {
          context: { type: 'CHARITY', id: currentUser.charityId },
          filter: { docTypes: FR_DOCUMENT_TYPES },
          page: 0,
          size: FR_DOCUMENT_TYPES.length,
        }
      : skipToken,
  );

  if (!isFR) {
    return { documents: [], isLoading: false, isError: false, charityId: undefined };
  }

  const hasNoCharityId = !isCurrentUserLoading && !currentUser?.charityId;

  return {
    documents: data?.documents ?? [],
    isLoading: isCurrentUserLoading || isDocumentsLoading,
    isError: isCurrentUserError || isDocumentsError || hasNoCharityId,
    charityId: currentUser?.charityId,
  };
};
